import React from "react";

const StyledH6Heading = ({ children, font }) => {
  return (
    <h6 className={`text-h6 font-star-jedi lowercase ${font}`}>{children}</h6>
  );
};

export default StyledH6Heading;
